export const formConfigData = {
  relatedToLand: {
    question:
      "Do you live in, own or rent land, or conduct traditional practices in the Netley-Grassmere-Willow Creek Watersheds?(Yes/No)",
    detail: "",
  },
  whoAreYou: {
    question: "Who are you?",
    detail:
      "(Agricultural Producer, Student, Rural Resident Urban Resident, Cottager, Hunter, Fisher, Camper, Recreation User, Indigenous person with historical and traditional rights in the Watershed and/or other(state below))",
  },
  nearestCommunity: {
    question: "What is the nearest community to where you live or own land?",
    detail: "",
  },
  assetName: {
    question:
      "What Watershed Natural Assets do you value most? Please name the selected location",
    detail: "",
  },
  assetThreatRisk: {
    question:
      "What are the threats and risks to these Watershed Natural Assets?",
    detail: "",
  },
  assetProtectMethodAlready: {
    question:
      "How are these Watershed Natural Assets currently being enhanced, protected, or conserved?",
    detail: "",
  },
  assetProtectMethodSuggestion: {
    question:
      "Do you have any suggestions for programs, projects, or activities that will help enhance, protect or conserve these Watershed Natural Assets?",
    detail: "",
  },
  whyImportant: {
    question: "Why/how are these Watershed Natural Assets important to you?",
    detail:
      "(socially, environmentally, and economically). Share your knowledge about them.",
  },
  userInfo: {
    question: "Please provide your name, number, and email address",
    detail:
      "if you would like to be entered into an additional draw, or be sent updates of the plan.",
  },
};
